// Kalipso - auto-fading sliders (.kx-slider with .kx-slide children).
// Optional manual controls, rendered only by the gallery: [data-kx-prev]/[data-kx-next]
// arrows and <button class="kx-sdot"> dots. Clicking one restarts the clock, so the
// slide never flips immediately after the shopper takes over.
// Autoplay is skipped under prefers-reduced-motion - the controls still work.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    document.querySelectorAll('.kx-slider').forEach(function (sl) {
      var slides = sl.querySelectorAll('.kx-slide');
      if (slides.length < 2) return;
      var dots = sl.querySelectorAll('.kx-sdot');
      var iv = parseInt(sl.getAttribute('data-interval'), 10) || 4000;
      var i = 0, timer = null;
      if (!slides[0].classList.contains('is-active')) slides[0].classList.add('is-active');

      function show(n) {
        n = (n % slides.length + slides.length) % slides.length;   // wrap both ways
        if (n === i) return;
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = n;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, iv); }
      function nav(n) { show(n); play(); }                          // restart the clock on manual nav

      var prev = sl.querySelector('[data-kx-prev]');
      var next = sl.querySelector('[data-kx-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); nav(i - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); nav(i + 1); });
      dots.forEach(function (d, n) {
        // zigzag dots are <span>s inside a card link - leave those inert
        if (d.tagName !== 'BUTTON') return;
        d.addEventListener('click', function (e) { e.preventDefault(); nav(n); });
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { play(); } });

      // stagger so not every slider flips at the same instant
      setTimeout(play, iv * Math.random());
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

// Kalipso - crossfading image hero for the interior page bands ([data-kx-phero]).
// Two stacked <img> layers swap opacity; a subtle Ken Burns zoom lives in CSS.
// Only the next image in the sequence is ever preloaded. Category swaps go through
// window.KxHero.setImages() / the 'kx:hero:setimages' event.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = [];

  function Hero(root) {
    this.root = root;
    var layers = root.querySelectorAll('.kx-phero__layer');
    if (layers.length < 2) return;
    this.layers = layers;
    this.imgs = [layers[0].querySelector('img'), layers[1].querySelector('img')];
    this.sizes = this.imgs[0].getAttribute('sizes') || '100vw';
    var data = root.querySelector('.kx-phero__data');
    try { this.urls = JSON.parse(data.textContent) || []; } catch (e) { this.urls = []; }
    // matching srcset per image, so swapped-in slides stay responsive too (not just the first)
    var sets = root.querySelector('.kx-phero__sets');
    try { this.sets = sets ? JSON.parse(sets.textContent) || [] : []; } catch (e) { this.sets = []; }
    this.hold = parseInt(root.getAttribute('data-hold'), 10) || 5500;
    this.fade = parseInt(root.getAttribute('data-fade'), 10) || 1200;
    this.active = 0;   // index of the currently visible layer
    this.idx = 0;      // index of the currently shown url
    this.timer = null;
    this.imgs[0].__idx = 0;

    if (!reduce) this.kick();               // ease the first (LCP) image from scale 1 -> 1.06
    if (this.urls.length > 1) {
      this.preload(1 - this.active, this.wrap(this.idx + 1)); // ready the next image only
      this.schedule();
      var self = this;
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) self.stop();
        else if (self.urls.length > 1 && !self.timer) self.schedule();
      });
    }
    instances.push(this);
  }

  Hero.prototype.wrap = function (i) { return (i % this.urls.length + this.urls.length) % this.urls.length; };

  // Reset only the hidden pan image. Two selected sources share one animation name,
  // so changing src alone would otherwise leave the next image at the finished frame.
  Hero.prototype.resetPan = function (img) {
    if (!window.getComputedStyle || window.getComputedStyle(img).animationName !== 'kx-phero-pan-down') return;
    img.style.animation = 'none';
    void img.offsetWidth;
    img.style.animation = '';
  };

  Hero.prototype.kick = function () {
    var img = this.imgs[this.active];
    img.style.transition = 'none';
    img.style.transform = 'scale(1)';
    void img.offsetWidth;                    // force reflow so the reset takes
    requestAnimationFrame(function () { img.style.transition = ''; img.style.transform = ''; });
  };

  // Load an image into a (hidden) layer without showing it - this is the only preload.
  Hero.prototype.preload = function (layerIdx, urlIdx) {
    var img = this.imgs[layerIdx];
    this.resetPan(img);                      // also restart a reused URL in a two-slide set
    if (img.__idx === urlIdx && img.getAttribute('src')) return;
    // set srcset BEFORE src so the browser picks the right candidate first time.
    // srcset wins over src, so a stale one must be cleared or the old image keeps showing.
    if (this.sets && this.sets[urlIdx]) { img.sizes = this.sizes; img.srcset = this.sets[urlIdx]; }
    else { img.removeAttribute('srcset'); }
    img.src = this.urls[urlIdx];
    img.__idx = urlIdx;
  };

  Hero.prototype.schedule = function () {
    this.stop();
    if (reduce) return;
    var self = this;
    // A slower vertical pan needs its full duration before the next crossfade.
    var delay = this.hold;
    var motion = window.getComputedStyle && window.getComputedStyle(this.imgs[this.active]);
    if (motion && motion.animationName === 'kx-phero-pan-down') {
      delay = Math.max(delay, parseFloat(motion.animationDuration) * 1000 || delay);
    }
    this.timer = setTimeout(function () { self.advance(); }, delay);
  };

  Hero.prototype.stop = function () { if (this.timer) { clearTimeout(this.timer); this.timer = null; } };

  Hero.prototype.advance = function () {
    if (this.urls.length < 2) return;
    var incoming = 1 - this.active;
    var next = this.wrap(this.idx + 1);
    this.preload(incoming, next);            // reuse loaded source, restart its hidden pan
    this.layers[incoming].classList.add('is-active');   // fade in + zoom (CSS)
    this.layers[this.active].classList.remove('is-active'); // fade out beneath
    this.active = incoming;
    this.idx = next;
    var self = this;
    setTimeout(function () { self.preload(1 - self.active, self.wrap(self.idx + 1)); }, this.fade + 60);
    this.schedule();
  };

  // Swap to a new image set (e.g. category change) using the same crossfade.
  Hero.prototype.setImages = function (urls) {
    if (!urls || !urls.length) return;
    this.stop();
    this.urls = urls.slice();
    this.sets = [];                     // a swapped-in set carries plain urls, no srcset
    var incoming = 1 - this.active;
    var img = this.imgs[incoming];
    this.resetPan(img);
    img.removeAttribute('srcset');      // else the stale srcset would override the new src
    img.src = this.urls[0];
    img.__idx = 0;
    var self = this;
    var go = function () {
      img.onload = null;
      self.layers[incoming].classList.add('is-active');
      self.layers[self.active].classList.remove('is-active');
      self.active = incoming;
      self.idx = 0;
      if (self.urls.length > 1) {
        setTimeout(function () { self.preload(1 - self.active, self.wrap(1)); }, self.fade + 60);
        self.schedule();
      }
    };
    if (img.complete && img.naturalWidth) go(); else img.onload = go;
  };

  window.KxHero = {
    instances: instances,
    // setImages(urls[, root]) - root optional; omit to update every hero on the page.
    setImages: function (urls, root) {
      instances.forEach(function (h) { if (!root || h.root === root) h.setImages(urls); });
    }
  };
  document.addEventListener('kx:hero:setimages', function (e) {
    var d = e.detail || {};
    window.KxHero.setImages(d.images, d.root);
  });

  function boot() { document.querySelectorAll('[data-kx-phero]').forEach(function (el) { new Hero(el); }); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* ==========================================================================
   Favourites - a wishlist that needs no customer account.
   Two kinds are saved independently: products (tiles) and collections (series).
   Handles live in localStorage, so a list belongs to one browser and does not
   follow the shopper across devices. Nothing is stored server-side.

   Markup contract:
     <button data-kx-fav="<handle>">                          -> product
     <button data-kx-fav="<handle>" data-kx-fav-kind="collection">
   ========================================================================== */
(function () {
  // localStorage throws in Safari private mode and can hold junk from an older
  // build - every read/write is guarded so a bad value can never break the page.
  function store(key) {
    function read() {
      try {
        var v = JSON.parse(localStorage.getItem(key));
        return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
      } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('kx:fav:change', { detail: { key: key, list: list } }));
    }
    return {
      key: key,
      all: read,
      has: function (h) { return read().indexOf(h) !== -1; },
      count: function () { return read().length; },
      add: function (h) { var l = read(); if (l.indexOf(h) === -1) { l.push(h); write(l); } },
      remove: function (h) { var l = read(), i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); } },
      // one write (so one re-render) when pruning several handles at once
      removeMany: function (hs) {
        var before = read();
        var l = before.filter(function (h) { return hs.indexOf(h) === -1; });
        if (l.length !== before.length) write(l);
      },
      clear: function () { write([]); },
      toggle: function (h) { if (this.has(h)) { this.remove(h); return false; } this.add(h); return true; }
    };
  }

  var KxFav = {
    products: store('kx:favourites'),
    collections: store('kx:fav-collections'),
    total: function () { return KxFav.products.count() + KxFav.collections.count(); },
    clear: function () { KxFav.products.clear(); KxFav.collections.clear(); },
    // which store a heart belongs to, from its markup
    storeFor: function (el) {
      return el.getAttribute('data-kx-fav-kind') === 'collection' ? KxFav.collections : KxFav.products;
    }
  };
  window.KxFav = KxFav;

  function paint() {
    document.querySelectorAll('[data-kx-fav]').forEach(function (btn) {
      var on = KxFav.storeFor(btn).has(btn.getAttribute('data-kx-fav'));
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      // Icon-only hearts carry an aria-label from Liquid and need it kept in sync.
      // Buttons with visible text (Запази колекцията) take their name from that text,
      // which CSS swaps on .is-on - setting a label here would override it.
      if (btn.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', on ? 'Премахни от любими' : 'Добави в любими');
      }
    });
    var n = KxFav.total();
    document.querySelectorAll('[data-kx-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // Delegated: cards fetched later (favourites page) get the behaviour for free.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kx-fav]') : null;
    if (!btn) return;
    e.preventDefault();   // the heart overlaps the card link
    e.stopPropagation();
    KxFav.storeFor(btn).toggle(btn.getAttribute('data-kx-fav'));
  });

  document.addEventListener('kx:fav:change', paint);
  // cards fetched into the favourites grids arrive after the initial paint and
  // would otherwise show an empty heart on the very page listing them
  document.addEventListener('kx:fav:painted', paint);
  // keep other open tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key === KxFav.products.key || e.key === KxFav.collections.key) paint();
  });

  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
})();

/* ---- favourites page: one server-rendered card per saved handle ---- */
(function () {
  function boot() {
    var page = document.querySelector('[data-kx-fav-page]');
    if (!page) return;                       // not the favourites page

    var empty = page.querySelector('[data-kx-fav-empty]');
    var body  = page.querySelector('[data-kx-fav-body]');
    var field = page.querySelector('[data-kx-fav-field]');
    var head  = page.querySelector('[data-kx-fav-headcount]');
    var clear = page.querySelector('[data-kx-fav-clear]');
    var inflight = {};

    // Each group renders its own kind. Card markup comes from Liquid via the
    // Section Rendering API so it stays identical to the rest of the site -
    // same money format, same badges - with no card markup duplicated in JS.
    var GROUPS = [
      { kind: 'collections', label: 'Колекции', base: '/collections/', section: 'kalipso-fav-collection-card' },
      { kind: 'products',    label: 'Продукти', base: '/products/',    section: 'kalipso-fav-card' }
    ].map(function (g) {
      g.group = page.querySelector('[data-kx-fav-group="' + g.kind + '"]');
      g.grid  = page.querySelector('[data-kx-fav-grid="' + g.kind + '"]');
      g.count = page.querySelector('[data-kx-fav-groupcount="' + g.kind + '"]');
      g.store = window.KxFav[g.kind];
      return g;
    }).filter(function (g) { return g.grid; });

    function summarise() {
      if (!field) return;
      var lines = [];
      GROUPS.forEach(function (g) {
        var items = g.grid.querySelectorAll('.kx-fav-item');
        if (!items.length) return;
        if (lines.length) lines.push('');
        lines.push(g.label + ':');
        items.forEach(function (it, i) {
          var sku = it.getAttribute('data-sku');
          lines.push('  ' + (i + 1) + '. ' + it.getAttribute('data-title') +
                     (sku ? ' (Артикул: ' + sku + ')' : '') +
                     ' - ' + it.getAttribute('data-url'));
        });
      });
      field.value = lines.join('\n');
    }

    function fetchCard(g, handle) {
      return fetch(g.base + encodeURIComponent(handle) + '?section_id=' + g.section)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          return new DOMParser().parseFromString(html, 'text/html').querySelector('.kx-fav-item');
        })
        .catch(function () { return null; });
    }

    function renderGroup(g) {
      var list = g.store.all();
      if (g.group) g.group.hidden = list.length === 0;
      if (g.count) g.count.textContent = list.length;

      // Drop cards that were just un-hearted, keep the rest mounted. Re-fetching the
      // whole grid on every toggle would flash and re-request every card.
      g.grid.querySelectorAll('.kx-fav-item').forEach(function (it) {
        if (list.indexOf(it.getAttribute('data-handle')) === -1) it.remove();
      });

      var have = {};
      g.grid.querySelectorAll('.kx-fav-item').forEach(function (it) {
        have[it.getAttribute('data-handle')] = true;
      });
      // New favourites are appended to the stored list, so appending here keeps the order.
      var missing = list.filter(function (h) { return !have[h] && !inflight[g.kind + ':' + h]; });
      if (!missing.length) return Promise.resolve();

      missing.forEach(function (h) { inflight[g.kind + ':' + h] = true; });
      g.grid.setAttribute('aria-busy', 'true');

      return Promise.all(missing.map(function (h) { return fetchCard(g, h); })).then(function (cards) {
        var dead = [];
        cards.forEach(function (card, i) {
          var handle = missing[i];
          delete inflight[g.kind + ':' + handle];
          // A handle that 404s was deleted or unpublished - drop it from storage
          // rather than leave a hole in the grid forever.
          if (!card) { dead.push(handle); return; }
          // it may have been un-hearted while the request was in flight
          if (g.store.has(handle)) g.grid.appendChild(card);
        });
        g.grid.removeAttribute('aria-busy');
        if (dead.length) g.store.removeMany(dead);
      });
    }

    function render() {
      var total = window.KxFav.total();
      if (head) head.textContent = total ? total + (total === 1 ? ' запазен' : ' запазени') : '';
      if (empty) empty.hidden = total > 0;
      if (body) body.hidden = total === 0;
      if (clear) clear.hidden = total === 0;

      Promise.all(GROUPS.map(renderGroup)).then(function () {
        summarise();
        document.dispatchEvent(new CustomEvent('kx:fav:painted'));
      });
    }

    if (clear) {
      clear.addEventListener('click', function () {
        if (window.confirm('Да премахнем ли всички любими?')) window.KxFav.clear();
      });
    }
    document.addEventListener('kx:fav:change', render);
    render();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

// Kalipso - lead-source attribution for the order-request form.
// This shop's ordering flow never reaches Shopify's checkout (see sections/main-cart-footer.liquid:
// the enquiry goes out through Shopify's contact form instead), so no Shopify order object is ever
// created and Shopify's own per-order "Conversion summary" attribution never exists. This records
// the equivalent ourselves so every enquiry email says how that customer found the shop.
// Two horizons are kept on purpose: the first visit ever (localStorage) and the current visit
// (sessionStorage). A shopper who arrives from Google, leaves, then returns days later by typing
// the address would otherwise be filed as "direct" - the first-touch value keeps the real origin.
(function () {
  var SESS = 'kx_attr_session', FIRST = 'kx_attr_first';

  // Storage throws, rather than no-ops, in Safari private mode and when the quota is full;
  // attribution is a nice-to-have, so every access is allowed to fail without breaking the page.
  function read(store, key) {
    try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function write(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  // Written for the shop owner reading the enquiry email, so the labels are Bulgarian and
  // plain-language rather than analytics jargon.
  // Returns {src, known}. "known" is false only for the final fall-through - a site we have no
  // label for - which is the one case where the caller appends the exact referring URL. Testing
  // the returned string instead would misfire on the one-word labels ("Facebook", "Instagram").
  function classify(ref, params) {
    var utm = params.get('utm_source');
    if (utm) {
      var med = params.get('utm_medium');
      return { src: utm + (med ? ' / ' + med : '') + ' (UTM)', known: true };
    }
    if (params.get('gclid')) return { src: 'Google Ads', known: true };
    var direct = { src: 'директно / без реферер', known: true };
    if (!ref) return direct;
    var host;
    try { host = new URL(ref).hostname.replace(/^www\./, ''); }
    catch (e) { return direct; }
    if (host === location.hostname.replace(/^www\./, '')) return direct;
    if (/(^|\.)google\./.test(host)) return { src: 'Google - органично търсене', known: true };
    if (/(^|\.)(bing|duckduckgo|yahoo|ecosia|yandex)\./.test(host)) return { src: host + ' - търсачка', known: true };
    if (/(^|\.)(facebook\.com|fb\.me|fb\.com)$/.test(host)) return { src: 'Facebook', known: true };
    if (/(^|\.)instagram\.com$/.test(host)) return { src: 'Instagram', known: true };
    if (/(^|\.)(t\.co|x\.com|twitter\.com)$/.test(host)) return { src: 'X / Twitter', known: true };
    if (/(^|\.)(youtube\.com|youtu\.be)$/.test(host)) return { src: 'YouTube', known: true };
    return { src: host, known: false };
  }

  var params = new URLSearchParams(location.search);
  var sess = read(sessionStorage, SESS);
  if (!sess) {
    var hit = classify(document.referrer, params);
    sess = {
      src: hit.src,
      known: hit.known,
      landing: location.pathname + (location.search || ''),
      ref: document.referrer || '',
      pages: 0,
      date: new Date().toISOString().slice(0, 10)
    };
  }
  sess.pages = (sess.pages || 0) + 1;
  write(sessionStorage, SESS, sess);

  if (!read(localStorage, FIRST)) {
    write(localStorage, FIRST, { src: sess.src, landing: sess.landing, date: sess.date });
  }

  // Only the cart page carries the form; everywhere else this module just keeps counting.
  function fill() {
    // the cart order form and the phone quick-request form (kx-quick-contact) both carry the fields
    var forms = [document.getElementById('kx-order-form'), document.getElementById('kx-qc-form')].filter(Boolean);
    if (!forms.length) return;
    var first = read(localStorage, FIRST) || {};
    // For a site we have no label for, the exact URL is worth having - it's how you find out
    // which blog or directory is linking to you. (known === undefined means a session stored
    // before this field existed; treat it as known so we don't append a URL to "Facebook".)
    var srcLine = sess.src;
    if (sess.ref && sess.known === false) srcLine += ' — ' + sess.ref;
    var map = {
      src: srcLine,
      first: first.src ? first.src + ' (' + (first.date || '') + ')' : '',
      landing: sess.landing,
      pages: String(sess.pages)
    };
    forms.forEach(function (form) {
      Object.keys(map).forEach(function (k) {
        var el = form.querySelector('[data-kx-attr="' + k + '"]');
        if (el) el.value = map[k];
      });
    });
  }

  if (document.readyState !== 'loading') fill();
  else document.addEventListener('DOMContentLoaded', fill);
})();
